module.exports = __webpack_public_path__ + "static/media/x-class-hero.6286f99a.jpg";